import { ToolType } from "api/resources/aiTools/types"
import { getToolName } from "features/AItools/helper"
import AIToolsOnboarding from "features/Home/SuraasaPlusNewYearOnboarding/AIToolsOnboarding"
import { AI_TOOLS_ONBOARDING_TARGETS } from "features/Home/SuraasaPlusNewYearOnboarding/AIToolsOnboarding/types"

import Heading from "../../Heading"
import ActivityPlannerOutput from "../GenerationOutput/ActivityPlannerOutput"
import ContentActions from "../GenerationOutput/Export/ContentActions"
import ProForm from "./ProForm"
import { useActivityPlanner } from "./useActivityPlanner"

const ActivityPlannerGenerator = ({
  toggleHistorySideBar,
}: {
  toggleHistorySideBar: (state: boolean) => void
}) => {
  const {
    currentResponseId,
    setCurrentResponseId,
    responseIds,
    overviewData,
    generateTool,
    regenerateResponse,
    userVote,
    isPositiveResponse,
    output,
    isLoading,
    onBack,
    formData,
    stream,
    setFormData,
    ...activityContext
  } = useActivityPlanner()

  if (currentResponseId) {
    return (
      <>
        <ContentActions
          onBack={onBack}
          currentResponseId={currentResponseId}
          toolType={ToolType.activityPlanner}
          title={overviewData?.title}
          toggleHistorySideBar={toggleHistorySideBar}
          hideExportOutputButton={
            stream.isError || isLoading || currentResponseId === undefined
          }
        />

        <ActivityPlannerOutput
          regenerateResponse={regenerateResponse}
          isPositiveResponse={isPositiveResponse}
          userVote={userVote}
          overviewData={overviewData}
          responseIds={responseIds}
          currentResponseId={currentResponseId}
          isLoading={isLoading}
          output={output}
          setCurrentResponseId={setCurrentResponseId}
          onBack={onBack}
          stream={stream}
        />
      </>
    )
  }
  return (
    <div data-tour={AI_TOOLS_ONBOARDING_TARGETS.describeActivity}>
      <Heading
        title={`${getToolName(ToolType.activityPlanner)} Generator`}
        subtitle="Elevate your teaching approach with the Activity Plan Generator, fostering interactive and impactful learning experiences."
        toggleHistorySideBar={toggleHistorySideBar}
      />
      <ProForm
        generateTool={generateTool}
        formData={formData}
        setFormData={setFormData}
        preferredPromptData={activityContext.preferredPromptData}
      />
      <AIToolsOnboarding />
    </div>
  )
}

export default ActivityPlannerGenerator
